import { render } from "./SubscriptionThankYou.vue?vue&type=template&id=00ba54de&scoped=true"
import script from "./SubscriptionThankYou.vue?vue&type=script&lang=js"
export * from "./SubscriptionThankYou.vue?vue&type=script&lang=js"

import "./SubscriptionThankYou.vue?vue&type=style&index=0&id=00ba54de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ba54de"]])

export default __exports__